import React from 'react';
import ACheckbox from 'antd-mobile/lib/checkbox';



export default class Checkbox extends ACheckbox {}
